<template>

    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '80px' } }">
            <!-- <a-form-item label="" name="fileName">
                <a-input v-model:value="formState.fileName" placeholder="" allowClear>
                </a-input>
            </a-form-item> -->

            <!-- <a-form-item label="" name="filePath">
                <a-input v-model:value="formState.filePath" placeholder="" allowClear>
                </a-input>
            </a-form-item> -->

            <!-- <a-form-item label="" name="fileSize">
                <a-input v-model:value="formState.fileSize" placeholder="" allowClear>
                </a-input>
            </a-form-item> -->

            <a-form-item label="类型" name="productType" v-if="modalConfig.accept === '.png,.jpg'">
                <a-select v-model:value="formState.productType" :options="machineOptions" placeholder="请选择类型"
                    allowClear>
                </a-select>
            </a-form-item>


            <a-form-item label="标题" name="title">
                <a-input v-model:value="formState.title" placeholder="请输入标题" allowClear>
                </a-input>
            </a-form-item>

            <a-form-item label="备注" name="notes" v-if="modalConfig.accept === '.png,.jpg'">
                <a-input v-model:value="formState.notes" placeholder="备注" allowClear>
                </a-input>
            </a-form-item>

            <a-form-item :label="uploadText" name="upload" v-if="modalConfig.accept">
                <a-upload v-model:file-list="fileList" :accept="modalConfig.accept" :customRequest="customRequest" :remove="handleRemoveFile">
                    <a-button v-if="fileList.length === 0">
                        <upload-outlined></upload-outlined>
                        点击上传
                    </a-button>
                </a-upload>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { saveProductVideo, uploadProductVideo } from '@/request/view/afterSale.js';
import { Toast } from "@/utils";
import { UploadOutlined } from '@ant-design/icons-vue';
import { machineOptions } from './data';
import { useStore } from "vuex";
import { computed } from "vue";

export default defineComponent({
    components: {
        UploadOutlined
    },
    setup(props, context) {
        const store = useStore();
        const formRef = ref();
        const fileList = ref([]);
        const formState = reactive({
            fileName: null,
            filePath: null,
            fileSize: null,
            id: null,
            notes: null,
            pid: null,
            productType: null,
            title: null
        });
        const rules = {
            notes: [{ required: true, message: '请输入备注', trigger: 'change' }],
            productType: [{ required: true, message: '请选择类型', trigger: 'change' }],
            title: [{ required: true, message: '请输入标题', trigger: 'change' }]
        };

        const uploadFile = (file) => {
            const mbsize = file.size / 1000 / 1000;
            const formData = new FormData();
            formData.append('file', file);
            return new Promise((resolve, reject) => {
                uploadProductVideo(formData, (e) => {
                    if (mbsize < 5) return;
                    const { loaded, total } = e;
                    const percent = ((loaded / total) * 100).toFixed(2);
                    store.commit('SET_LOADING_STATUS', {
                        status: true,
                        msg: `上传中 ${percent}%`,
                    })
                }).then((res) => {
                    resolve(res)
                    store.commit('SET_LOADING_STATUS', {
                        status: false,
                        msg: '',
                    })
                }).catch((err) => {
                    reject(err)
                    store.commit('SET_LOADING_STATUS', {
                        status: false,
                        msg: '',
                    })
                })
            });
        }

        const customRequest = async (e) => {
            const uploadInfo = await uploadFile(e.file);
            if (uploadInfo && uploadInfo.message === '上传成功') {
                e.onSuccess(uploadInfo.data, e);
                formState.fileSize = e.file.size;
                formState.filePath = uploadInfo.data;
            } else {
                e.onError(uploadInfo.message);
            }
        };

        const modalConfig = reactive({
            visible: false,
            title: null,
            accept: "",
        });

        const showModal = (options, data) => {
            const { title, accept } = options;
            if (data) {
                Object.keys(formState).forEach((key) => {
                    formState[key] = data[key];
                });
            }

            if (title === '设备分类') {
                formState.pid = 0
            }

            modalConfig.title = title;
            modalConfig.visible = true;
            modalConfig.accept = accept;

            const setFileList = (url) => {
                const time = new Date();
                const name = url.slice(url.lastIndexOf("/") + 1, url.length);
                fileList.value.push({
                    uid: time.getTime() + Math.random(5),
                    status: "done",
                    name,
                    url,
                });
            }

            if (formState.filePath) setFileList(formState.filePath)
        };

        

        const uploadText = computed(() => {
            let text = '';
            if (modalConfig.accept === '.png,.jpg') text = '上传图片';
            if (modalConfig.accept === '.mp4') text = '上传视频';
            return text;
        });

        const handleRemoveFile = (e) => {
            if (e.url === formState.filePath) formState.filePath = '';
        };

        const handleCancel = () => {
            resetForm();
            modalConfig.title = null;
            modalConfig.accept = null;
            modalConfig.visible = false;
            fileList.value.length = 0;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formRef.value.clearValidate();
        };

        const handleOk = () => {
            formRef.value
                .validateFields()
                .then((res) => {
                    saveProductVideo(formState).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        };

        return {
            formState,
            rules,
            formRef,
            uploadText,
            showModal,
            handleCancel,
            handleOk,
            customRequest,
            handleRemoveFile,
            fileList,
            modalConfig,
            machineOptions,
            uploadProductVideo,
        };
    },
});
</script>